export class Commission {

    public static isCommissionValid(commission: Commission): boolean {
        return commission.libelle != null && commission.libelle.trim().length > 0 &&
            commission.dateLimiteAvis != null && commission.heureLimiteAvis != null &&
            commission.dateCommission != null && commission.heureCommission != null &&
            commission.datePublication != null && commission.heurePublication != null &&
            commission.dateLimiteConfirmation != null && commission.heureLimiteConfirmation != null;
    }
    public static isCommissionConfirmationValid(commission: Commission): boolean {
        if (!commission) return false;

        const now = new Date();
        const dateLimiteConfirmation = new Date(commission.dateLimiteConfirmation);

        return commission.libelle != null &&
            commission.libelle.trim().length > 0 &&
            commission.dateLimiteAvis != null &&
            commission.heureLimiteAvis != null &&
            commission.dateCommission != null &&
            commission.heureCommission != null &&
            commission.datePublication != null &&
            commission.heurePublication != null &&
            commission.dateLimiteConfirmation != null &&
            commission.heureLimiteConfirmation != null &&
            dateLimiteConfirmation >= now;
    }
    public formatDateLimiteConfirmation(lang: string): string {
        if (!this.dateLimiteConfirmation) return null;

        const date = new Date(this.dateLimiteConfirmation);
        if (lang === 'fr') {
            return date.toLocaleString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            });
        } else {
            return date.toLocaleString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            });
        }
    }

    constructor(
        public id?: number,
        public libelle?: string,
        public dateCommission?: any,
        public heureCommission?: any,
        public datePublication?: any,
        public heurePublication?: any,
        public dateCoupure?: any,
        public heureCoupure?: any,
        public dateLimiteAvis?: any,
        public heureLimiteAvis?: any,
        public dateLimiteConfirmation?: any,
        public heureLimiteConfirmation?: any,
        public campagnes?: any[],
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/commission/commission.model.ts